module.exports = __webpack_public_path__ + "img/ea_bg5.39d2429a.jpg";